import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Product.scss';

export default function Cpu() {
  const [cpus, setCpus] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        const cpuItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'cpu'
        );

        setCpus(cpuItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="cpu">
      <h1>Процессоры</h1>
      <div className="cpu__list">
        {cpus.length > 0 ? (
          cpus.map((cpu) => (
            <div key={cpu.id} className="cpu__card">
              <img src={cpu.image} alt={cpu.name} />
              <h2>{cpu.name}</h2>
              <p className="specs">{cpu.description}</p>
              <p className="price">{cpu.price}</p>
              <Link to={`/components/cpu/${cpu.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
